import { Station, StationApi } from 'kiolyn-api';
import IStationRepository from '../domain/repositories/IStationRepository';

export default class StationRepository implements IStationRepository {
  private readonly api: StationApi;

  constructor(basePath: string) {
    this.api = new StationApi({
      basePath
    });
  }

  public async loadMainStation(storeid: string): Promise<Station | undefined> {
    try {
      const data = (await this.api.loadMainStation(storeid)).data;
      return data.value;
    } catch (error) {
      return undefined;
    }
  }
}
